import { render } from "./AdminApproved75Liquidations.vue?vue&type=template&id=8382432e"
import script from "./AdminApproved75Liquidations.vue?vue&type=script&lang=js"
export * from "./AdminApproved75Liquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__